import { render, staticRenderFns } from "./SingleMovie.vue?vue&type=template&id=996f0c20&scoped=true"
import script from "./SingleMovie.vue?vue&type=script&lang=js"
export * from "./SingleMovie.vue?vue&type=script&lang=js"
import style0 from "./SingleMovie.vue?vue&type=style&index=0&id=996f0c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996f0c20",
  null
  
)

export default component.exports